import {Card, CardContent, CardProps, SvgIcon, Typography} from "@material-ui/core";
import React, {FC} from "react";
import {useHistory} from "react-router-dom";

interface MenuButtonProps {
    icon: typeof SvgIcon;
    label: string;
    navigateTo: string;
    cardProps?: CardProps;
}

export const MenuButton: FC<MenuButtonProps> = (props) => {
    const history = useHistory();
    const IconComponent = props.icon;

    const handleButtonClicked = () => history.push(props.navigateTo);

    return (
        <Card {...props.cardProps} onClick={handleButtonClicked}>
            <CardContent style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                <Typography color="primary" variant="h5">{props.label}</Typography>
                <IconComponent fontSize="large" color="primary"/>
            </CardContent>
        </Card>
    )
}